#chat-message-bar {
  display: flex;
  align-items: stretch;
  width: 100%;
  gap: 10px;
}


#chat-textarea {
  width: 100%;
  box-sizing: border-box;
  font-family: Frutiger-Light, sans-serif;
  font-size: 16px;
  padding: 6px 30px 6px 15px;
  border: 1px solid var(--ux-input-border-color);
  resize: none;
  overflow: auto;
  line-height: 1;

  &::placeholder {
    vertical-align: middle;
  }
}

ux-button {
  flex-shrink: 0;
  align-self: self-start;
  --ux-icon-button-width: 46px;
  --ux-icon-button-height: 46px;
  --ux-button-icon-size-large: 20px;
}